<template>
  <div v-if="version" class="product-version-badge">
    Thai Smart Tax {{ version }}
  </div>
</template>

<script>
import fc from "@/firebaseConfig";
import configVersions from "@/config/product-versions";

const NS_THAI_SMART_TAX_ROUTES = [
  "Company.ReportThaiTax",
  "Company.TaxSales",
  "Company.TaxBuy",
  "Company.TaxBuyAverage",
  "Company.taxSupplementaryReport",
  "Company.TaxSupplementaryReportPP36",
  "Company.TaxReport",
  "Company.CancelValueAddedTax",
  "Company.CancelValueAddedTaxPP36",
  "Company.CancelValueAddedTaxPP54",
  "Company.ReportNetsuiteThaiTax",
  "Company.WithholdingTax",
  "Company.WithholdingIncomTax",
  "Company.WithholdingIncomTax.Cancel",
  "Company.Documents.PND54",
  "Company.Documents.PP36",
  "Company.Documents.PP36NTST",
  "Company.CancelPP36NTST",
];

export default {
  name: "ProductVersionBadge",
  data() {
    return {
      version: "",
    };
  },
  computed: {
    isNsThaiSmartTaxPage() {
      return NS_THAI_SMART_TAX_ROUTES.includes(this.$route.name);
    },
  },
  watch: {
    isNsThaiSmartTaxPage: {
      immediate: true,
      handler(val) {
        if (val) this.loadVersion();
        else this.version = "";
      },
    },
  },
  methods: {
    async loadVersion() {
      try {
        const doc = await fc.db.collection("ProductVersions").doc("PSC").get();
        const data = doc.exists ? doc.data() : {};
        const info = data.isNsThaiSmartTax;
        if (info && info.version) {
          this.version = info.version;
          return;
        }
      } catch (e) {
        // fall through to config fallback
      }
      this.version = configVersions.isNsThaiSmartTax?.version || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.product-version-badge {
  position: absolute;
  right: 12px;
  bottom: 12px;
  z-index: 100;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.35);
  pointer-events: none;
  user-select: none;
  font-family: "Noto Sans Thai", "Noto Sans", sans-serif;
}
</style>
